import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    cardRightButton: {
        margin: '0px 0px 0px 10px',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(1),
        padding: theme.spacing(0, 1),
        "& svg": {
            margin: 0,
            width: "22px",
            height: "22px",
            fill: theme.palette.primary.main,
        },
    },
    container: {
        padding: '8px',
        "& .MuiTypography-body1": {
            fontSize: 12
        }
    },
    tipoBox: {
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.primary.main,
        padding: '2px 5px',
    },
    card: {
        marginTop: theme.spacing(1),
    },
    descricaoLimitada: {
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxHeight: '40px', // Altura estimada para 2 linhas
        lineHeight: '1.5em',
    },
}))